import Vue from 'vue';
import get from 'lodash/get';
import head from 'lodash/head';
import isNil from 'lodash/isNil';
import indexOf from 'lodash/indexOf';

import { apolloClient } from '@/plugins/vue-apollo';
import { resetRouter, extendRouter } from '@/router';
import { fetchUserProfile } from '@/store/graphql/queries/user';
import AuthService from '@/services/AuthService';
import Routes from '@/router/routes';

export default {
  namespaced: true,
  state: {
    currentUser: null,
    currentRole: null,
    routesAssgineds: 'public',
    currentRoutes: [],
    principalRoles: ['buyer', 'supplier'],
    allowedRoles: ['mro_buyer', 'mro_supplier', 'mro_manage_supplier'],
    loadingDefaultPage: true,
  },
  actions: {
    assignRoutes({ commit }) {
      commit('SET_ASSIGNED_ROUTES');
    },
    setCurrentUser({ commit }, currentUser) {
      commit('SET_CURRENT_USER', get(currentUser, 'profile'));
      commit('SET_ASSIGNED_ROUTES');
    },
    login() {
      new AuthService().login();
    },
    logout() {
      new AuthService().logout();
    },
    async update({ dispatch }) {
      const currentUser = await new AuthService().update();
      dispatch('setCurrentUser', currentUser);
    },
    async getUserProfile({ commit }) {
      try {
        const userProfileQuery = {
          mutation: fetchUserProfile,
        };
        const result = await apolloClient.mutate(userProfileQuery);
        if (result && result.data && result.data.user_profile) {
          commit('SET_CURRENT_USER_PROFILE', head(result.data.user_profile));
        }
        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
    setLoadingDefaultPageToFalse({ state }) {
      state.loadingDefaultPage = false;
    },
  },
  mutations: {
    SET_CURRENT_USER_PROFILE(state, userProfile) {
      const profile = {
        userId: userProfile.id,
        firstName: userProfile.first_name,
        lastName: userProfile.last_name,
        fullName: `${userProfile.first_name} ${userProfile.last_name}`,
        activated: !isNil(userProfile.activated_at),
        locked: !isNil(userProfile.locked_at),
        organization: head(userProfile.organizations),
        email: userProfile.email,
        role: userProfile.role,
        phone: userProfile.phone,
        contact_type: userProfile.contact_type,
      };
      Vue.set(state.currentUser, 'profile', profile);
    },
    SET_CURRENT_USER(state, currentUser) {
      Vue.set(state, 'currentUser', currentUser);
    },
    SET_ASSIGNED_ROUTES(state) {
      if (!state.currentUser) return;
      const defaultRole = get(state.currentUser, 'x-hasura-default-role');
      if (!defaultRole) {
        Vue.set(state, 'routesAssigneds', 'public');
        return;
      }
      const currentAllowedRoles = get(state.currentUser, 'x-hasura-allowed-roles');
      // Lower case currentAllowedRoles
      let currentUserRole = null;
      if (indexOf(currentAllowedRoles, 'mro_mdm_user') !== -1) {
        currentUserRole = 'mro_mdm_user';
      } else if (indexOf(currentAllowedRoles, 'mro_buyer') !== -1) {
        currentUserRole = 'mro_buyer';
      } else if (indexOf(currentAllowedRoles, 'mro_manage_supplier') !== -1) {
        currentUserRole = 'mro_manage_supplier';
      } else if (indexOf(currentAllowedRoles, 'mro_supplier') !== -1) {
        currentUserRole = 'mro_supplier';
      } else {
        currentUserRole = defaultRole;
      }

      if (state.routesAssigneds !== currentUserRole) {
        let newRoutes = null;
        if (currentUserRole === 'mro_mdm_user') {
          // It's not the org id, it's actually the tax id and it's unique and unchangeable
          if (state.currentUser['x-hasura-organization-id'] === '89468900-5') newRoutes = Routes.mro_mdm_user('collahuasi');
          else if (state.currentUser['x-hasura-organization-id'] === '93920000-2') newRoutes = Routes.mro_mdm_user('amsa');
        } else newRoutes = Routes[currentUserRole];
        if (newRoutes && newRoutes.length) {
          extendRouter(newRoutes);
          window.localStorage.setItem('role', currentUserRole);
          Vue.set(state, 'currentRoutes', newRoutes);
          Vue.set(state, 'currentRole', currentUserRole);
          Vue.set(state, 'routesAssigneds', currentUserRole);
        } else {
          window.localStorage.removeItem('role');
          resetRouter();
        }
      }
      // true if hasHasuraClaims && mainRoleIsSupplier and !hasAccessToCAT4MRO
      if (state.currentRoutes.length === 0 && defaultRole === 'supplier') {
        const newRoutes = Routes.publicPaths;
        extendRouter(newRoutes);
        window.localStorage.setItem('role', defaultRole);
        Vue.set(state, 'currentRoutes', newRoutes);
        Vue.set(state, 'routesAssigneds', 'publicPaths');
        Vue.set(state, 'currentRole', defaultRole);
      }
    },
  },
  getters: {
    currentUser: state => state.currentUser,
    currentUserRoleInfo: state => state.currentRole,
    currentUserProfileInfo: (state) => {
      const currentUser = state.currentUser;
      if (!currentUser) {
        return null;
      }
      return currentUser.profile;
    },
    isAuthenticated: async () => {
      const data = await new AuthService().getUser();
      return data;
    },
    routesAssignedsInfo: state => state.routesAssigneds,
    currentRoutesInfo: state => state.currentRoutes,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/core/auth.js